import { Controller } from "@hotwired/stimulus";

const SIDEBAR_COLLAPSED_KEY = "sidebar_collapsed";
export default class extends Controller {
  static targets = ["sidebar", "submenu", "keyword", "cta", "ctatitle"];

  connect() {
    if (localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === "true") {
      this.sidebarTarget.classList.add("collapsed");
      this.submenuTargets.forEach(el => el.classList.add("hidden"));
      const next = this.element.nextElementSibling;
      if (!next) return;
      next.classList.remove("ml-64");
      next.classList.add("ml-16");
    }

    // CTA migration logic
    if (this.hasCtaTarget && this.ctaTarget.dataset.ctaId) {
      const ctaId = this.ctaTarget.dataset.ctaId;
      const localKey = `cta_${ctaId}_dismissed`;
      const isDismissed = localStorage.getItem(localKey) === 'true';
      if (isDismissed) {
        this.ctaTarget.classList.add("hidden");
      } else {
        // Check for old cookie
        const cookieName = `cta_${ctaId}_dismissed`;
        const cookieMatch = document.cookie.match(new RegExp('(?:^|; )' + cookieName.replace(/([.$?*|{}()\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
        if (cookieMatch && cookieMatch[1] === 'true') {
          localStorage.setItem(localKey, 'true');
          this.ctaTarget.classList.add("hidden");
        }
      }
    }

    this.expand_active_submenus();
  }

  collapse_click() {
    const wasCollapsed = localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === "true"

    if (wasCollapsed) {
      this.expand_sidebar();
    } else {
      this.collapse_sidebar();
    }
  }

  expand_sidebar() {
    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, "false");
    this.sidebarTarget.classList.remove("collapsed");
    this.submenuTargets.forEach(el => el.classList.add("hidden"))

    const next = this.element.nextElementSibling;
    if (!next) return;

    next.classList.remove("ml-16");
    next.classList.add("ml-64");
  }

  collapse_sidebar() {
    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, "true");
    this.sidebarTarget.classList.add("collapsed");
    this.submenuTargets.forEach(el => el.classList.add("hidden"))

    const next = this.element.nextElementSibling;
    if (!next) return;

    next.classList.remove("ml-64");
    next.classList.add("ml-16");
  }

  search_click() {
    const wasCollapsed = localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === "true"
    if (wasCollapsed) {
      this.expand_sidebar();
    }
    this.keywordTarget.focus();
  }

  search() {
    const keyword = this.keywordTarget.value.toLowerCase();
  }

  submenu_click(event) {
    event.preventDefault();
    const submenuId = event.currentTarget.dataset.submenuId;
    this.toggle_submenu(submenuId, event.currentTarget);
  }

  toggle_submenu(submenuId, buttonElement) {
    const submenu = document.getElementById(submenuId);
    const arrowDown = buttonElement.querySelector('[data-navigation-target="arrow-down"]');
    const arrowUp = buttonElement.querySelector('[data-navigation-target="arrow-up"]');

    if (!this.sidebarTarget.classList.contains("collapsed")) {
      if (submenu && submenu.dataset.navigationTarget === "submenu") {
        submenu.classList.toggle("hidden");
        if (arrowDown && arrowUp) {
          arrowDown.classList.toggle("hidden");
          arrowUp.classList.toggle("hidden");
        }
      }
    }
  }

  expand_active_submenus() {
    this.submenuTargets.forEach(submenu => {
      const activeItems = submenu.querySelectorAll('a span.text-primary-400');
      if (activeItems.length > 0) {
        const submenuId = submenu.id;
        const buttonElement = document.querySelector(`[data-submenu-id="${submenuId}"]`);
        if (buttonElement) {
          this.toggle_submenu(submenuId, buttonElement);
        }
      }
    });
  }

  dismiss_click() {
    this.ctaTarget.classList.add("hidden");
    
    // Get the CTA ID from the data attribute
    const ctaId = this.ctaTarget.dataset.ctaId;
    
    if (ctaId) {
      // Use local storage with the CTA ID
      console.log('ctaId', ctaId)
      localStorage.setItem(`cta_${ctaId}_dismissed`, 'true');
    } else {
      // Fallback to the old cookie-based method for backward compatibility
      const cta_title = this.ctatitleTarget.textContent
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '');
      document.cookie = `${cta_title}=true; path=/;`;
    }
  }

  darkmode_toogle() {
    document.documentElement.classList.toggle('dark');
  }

  cta_click() {
    const wasCollapsed = localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === "true"
    if (wasCollapsed) {
      this.expand_sidebar();
    }
  }
}
